module.exports = __webpack_public_path__ + "img/home-help3.7a6d7bfc.png";